// PMS is a documented accepted-as-is exception (CLAUDE.md, audit Section 6) —
// raw axios retained, RTK Query migration skipped. File-scope disable for
// the wire-shape `any`s until that decision changes.
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { type AxiosResponse } from 'axios';

import { getAPIUrls } from '../../../../util/env';
import { PMSVendorData } from '@/types/pms.types';
import type { PmsAccountRef } from '../../services/pmsAccount';

export const testVendorConnectionAPI = (
  formValues: PMSVendorData,
  vendorName = ''
): Promise<any> => {
  const APIUrl = '/property-service/api/v1/properties/pms'; // remove vendorName from  url
  const API_URL: string = getAPIUrls(APIUrl);
  formValues = {
    ...formValues,
    pmsSource: vendorName
  };
  return axios.post(`${API_URL}`, formValues);
};

/** property-service TestConnectionResponse: `status` is "Success" or "Failed"; key/secret redacted (DV-3414). */
export interface TestConnectionResponse {
  status: string | null;
  url: string | null;
}

export const testVendorConnectionSyncAPI = (
  account: PmsAccountRef,
  formValues: PMSVendorData,
  autoSyncAssets: boolean | undefined,
  watermarkedPhotos: boolean | undefined,
  vendorName = ''
): Promise<AxiosResponse<TestConnectionResponse>> => {
  const API_URL: string = getAPIUrls('/property-service/api/v1/properties/pms');
  const body: PMSVendorData = { ...formValues, autoSyncAssets, watermarkedPhotos, pmsSource: vendorName };
  // DV-3414: name the account so the server can fill a blank key/secret from what it
  // stores for it (a customer may only name their own; staff may name any). DV-3345:
  // the caller passes that account.
  return axios.post<TestConnectionResponse>(`${API_URL}?entity=${encodeURIComponent(account)}`, body);
};

export const saveConnectionAPI = (token: string): Promise<any> => {
  const APIUrl = '/property-service/api/v1/properties/buildium/saveConnection';
  const API_URL: string = getAPIUrls(APIUrl);
  return axios.post(API_URL, { jwt: token });
};

export const maskKey = (key: string) => {
  let maskedKey = '';
  if (key && key?.length > 0) {
    const lastChar = key.substring(key.length - 4);
    maskedKey = '*'.repeat(key.length - 3).concat(lastChar);
  }
  return maskedKey;
};

export const convertToPasswordFormat = (secretKey: string): string => {
  if (secretKey) {
    const noOfChar = secretKey.length;
    return '*'.repeat(noOfChar);
  }
  return '';
};
